











































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Department, departmentAdminApis, InvalidParam } from '../../api';
import EmployeeSelect from '@/components/EmployeeSelect.vue';
import { siteApis } from '@/api/site.api';

@Component({ components: { EmployeeSelect } })
export default class DepartmentEditDialog extends Vue {
  readonly rules = {
    name: { required: true, message: '请填写部门名称' }
  };
  readonly labelWidth = '6rem';
  @Prop({ default: () => false }) appendToBody!: boolean;
  dialogVisible = false;
  department: Department | null = null;
  resolve: ((d: Department) => void) | null = null;
  errors = {};
  loading = false;
  sites = [];

  mounted() {
    siteApis.listSites('').then(sites => (this.sites = sites));
  }
  show(department: Department | null) {
    if (department) {
      if (department.parent_id === -1) {
        department.parent_id = undefined;
      }
      this.department = JSON.parse(JSON.stringify(department));
    } else {
      this.department = {} as Department;
    }
    this.dialogVisible = true;
    return new Promise<Department>(resolve => (this.resolve = resolve));
  }

  async save() {
    if (this.department) {
      this.errors = {};
      try {
        const department = await departmentAdminApis.save(this.department);
        if (this.resolve) {
          this.resolve(department);
          this.resolve = null;
        }
        this.dialogVisible = false;
        this.$notify.success(`保存部门[${department.name}]成功`);
      } catch (e) {
        if (e instanceof InvalidParam) {
          this.errors = e.params;
        } else {
          this.$notify.error(e.message);
        }
      }
    }
  }

  onClosed() {
    this.department = null;
    this.resolve = null;
  }

  async getSites(query: string) {
    this.loading = true;
    await siteApis.listSites(query).then(sites => (this.sites = sites));
    this.loading = false;
  }
}
